module.exports = __webpack_public_path__ + "img/banner.7feaf62d.png";